import { AGREEMENT } from '../../constants/agreement';

export const methods = {

  getCurrentTime() {
    const today = new Date();
    return today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
  },
  formatDate(date, withMinutes = false) {
    if (date == null || '' === date) {
      return null;
    }
    let d = new Date(date);
    let minutes = '';
    if (withMinutes) {
      minutes = ' ' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
    }
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2) + minutes;
  },
  formatDateCreatedAt(date, withMinutes = false) {
    if (date == null) {
      return null;
    }
    let d = new Date(date.replace(/\s/, 'T'));
    let minutes = '';
    if (withMinutes) {
      minutes = ' ' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
    }
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2) + minutes;
  },

  getStatusIconAndColor(statusId) {
    if (!Number.isInteger(statusId)) {
      statusId = parseInt(statusId);
    }

    let responseData = {
      color: '',
      icon: '',
    };
//
// colors added in _customClasses.scss
    switch (statusId) {
      case 1:
        responseData.color = 'newBlue';
        responseData.icon = 'UserPlusIcon';
        break;
      case 2:
        responseData.color = 'danger';
        responseData.icon = 'PhoneOffIcon';
        break;
      case 3:
        responseData.color = 'warning';
        responseData.icon = 'PhoneCallIcon';
        break;
      case 4:
        responseData.color = 'successlight';
        responseData.icon = 'MailIcon';
        break;
      case 5:
        responseData.color = 'successlight-2';
        responseData.icon = 'UserCheckIcon';
        break;
      case 6:
        responseData.color = 'successlight-3';
        responseData.icon = 'DownloadIcon';
        break;
      case 7:
        responseData.color = 'successlight-4';
        responseData.icon = 'CreditCardIcon';
        break;
      case 8:
        responseData.color = 'success';
        responseData.icon = 'AwardIcon';
        break;
      case 9:
        responseData.color = 'success';
        responseData.icon = 'PlusIcon';
        break;
      default:
        responseData.color = 'primary';
        responseData.icon = 'InfoIcon';
        break;
    }
    return responseData;
  },

  getAgreementColorById(id) {
    switch (id) {
      case AGREEMENT.AGREEMENT_TYPE.UMOWA_O_PRACE:
        return this.getAgreementColorByPrefix(AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_O_PRACE);
      case AGREEMENT.AGREEMENT_TYPE.UMOWA_NA_OKRES_PROBNY:
        return this.getAgreementColorByPrefix(AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_NA_OKRES_PROBNY);
      case AGREEMENT.AGREEMENT_TYPE.UMOWA_NA_ZASTEPSTWO:
        return this.getAgreementColorByPrefix(AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_NA_ZASTEPSTWO);
      case AGREEMENT.AGREEMENT_TYPE.UMOWA_O_DZIELO:
        return this.getAgreementColorByPrefix(AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_O_DZIELO);
      case AGREEMENT.AGREEMENT_TYPE.UMOWA_ZLECENIE:
        return this.getAgreementColorByPrefix(AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_ZLECENIE);
      case AGREEMENT.AGREEMENT_TYPE.UMOWA_POWOLANIE:
        return this.getAgreementColorByPrefix(AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_POWOLANIE);
      default:
        return '';
    }
  },

  getAgreementColorByPrefix(prefix) {
    switch (prefix) {
      case AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_O_PRACE:
        return 'danger';
      case AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_NA_OKRES_PROBNY:
        return 'danger';
      case AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_NA_ZASTEPSTWO:
        return 'danger';
      case AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_O_DZIELO:
        return 'warning';
      case AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_ZLECENIE:
        return 'success';
      case AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_POWOLANIE:
        return 'newBlue';
      case 'UKK':
        return 'success';
      case 'UBR':
        return 'success';
      default:
        return '';
    }
  },

  getAgreementNamesByPrefix(prefix) {
    switch (prefix) {
      case AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_O_PRACE:
        return 'Umowa o pracę';
      case AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_NA_OKRES_PROBNY:
        return 'Umowa na okres próbny';
      case AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_NA_ZASTEPSTWO:
        return 'Umowa na zastępstwo';
      case AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_O_DZIELO:
        return 'Umowa o dzieło';
      case AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_ZLECENIE:
        return 'Umowa zlecenie';
      case AGREEMENT.AGREEMENT_TYPE_PREFIX.UMOWA_POWOLANIE:
        return 'Umowa powołanie';
      case 'UKK':
        return 'Umowa o świadczenie usług księgowych i kadrowych';
      case 'UBR':
        return 'Umowa dla biura rachunkowego';
      default:
        return '';
    }
  },

  getPrimaryColorByModule(module) {
    return '#6252dd';
  },

  prepareMainCompanyData: () => {
    let storagePerson = JSON.parse(localStorage.getItem('person'));

    if (!storagePerson) {
      return { company: null, person: null };
    }

    return {
      // return email if company doesnt exist
      company: (storagePerson.company && storagePerson.company.name) ? storagePerson.company.name : storagePerson.login_email,
      // return empty for person without name and surname
      person: (storagePerson.name && storagePerson.surname) ? storagePerson.name + ' ' + storagePerson.surname : '',
    };
  },
  calculateBrutto(net_price, vat_id) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/helper/calculate_gross', {
      net_price,
      vat_id,
    });
  },

  clearWhiteSpacesAndSpecialCharacter(text) {
    return text.replace(/[^A-Za-z0-9]/gi, '');
  },
};
